import get from 'lodash/get';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TextButton from '@spothero/ui/text-button';
import GTMUtils from 'utils/gtm';
import SegmentUtils from 'utils/segment';
import SHUtils from 'utils/sh-utils';
import Card from 'common/card/Card';
import Image from 'common/image/Image';
import Promo from 'common/promo/Promo';
import LookBookPark from './LookBookPark';
import HomeHero from './HomeHero';
import HomeAppPromo from './HomeAppPromo';
import {Helmet} from 'react-helmet-async';

export class Home extends Component {
    static propTypes = {
        email: PropTypes.string,
        referrer: PropTypes.string,
        referrerAffiliate: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        heroTitle: PropTypes.string,
        // horizontalPromos: PropTypes.array,
        // verticalPromos: PropTypes.array,
    };

    componentDidMount() {
        const {referrer, referrerAffiliate} = this.props;

        SegmentUtils.page({
            name: 'Web Landing',
            properties: {
                referrer: referrer || document.referrer,
                'referrer affiliate': referrerAffiliate,
            },
        });

        GTMUtils.push({
            event: 'pageview',
            page: 'home',
        });

        SHUtils.staticScrollTo();
    }

    render() {
        const {email, heroTitle} = this.props;
        const promoTypes = ['horizontal', 'vertical']
            .map(orientation => {
                const promos = this.props[`${orientation}Promos`];

                return promos ? {orientation, promos} : null;
            })
            .filter(Boolean);

        return (
            <div className="Home">
                <Helmet>
                    <link rel="canonical" href="https://spothero.com" />
                </Helmet>
                <HomeHero title={heroTitle} />
                <div className="Home-content">
                    <div className="Home-covid">
                        <Image
                            cloudinaryImageId="homepage/shield"
                            width={20}
                            height={24}
                            alt="COVID-19 Shield"
                        />
                        <p>
                            <span>COVID-19 Response.</span> See how we&apos;re
                            making parking safer and easier.{' '}
                            <TextButton href="https://blog.spothero.com/covid-19">
                                Learn more
                            </TextButton>
                        </p>
                    </div>
                    <section className="Home-container">
                        <LookBookPark />
                    </section>
                    {Boolean(promoTypes.length) && (
                        <section className="Home-container Home-promos-container">
                            {promoTypes.map(({orientation, promos}) => (
                                <div
                                    className={`Home-cards Home-cards-${orientation}`}
                                    key={orientation}
                                >
                                    {get(promos, 'title') && (
                                        <h1 className="Home-heading">
                                            {promos.title}
                                        </h1>
                                    )}
                                    {promos.cards.map((card, index) => (
                                        <Card key={index} noPadding>
                                            <Promo
                                                orientation={orientation}
                                                imageId={`homepage/${card.imageId}`}
                                                imagePosition={
                                                    card.imagePosition
                                                }
                                                title={card.title}
                                                content={card.description}
                                                buttonText={card.buttonText}
                                                buttonLink={card.url}
                                                links={card.links}
                                            />
                                        </Card>
                                    ))}
                                </div>
                            ))}
                        </section>
                    )}
                    <section className="Home-container Home-apps-container">
                        <HomeAppPromo email={email} />
                    </section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        page: {
            data: {heroTitle, horizontalPromos, verticalPromos},
        },
        user: {
            data: {email},
        },
        search: {
            data: {referrer, referrerAffiliate},
        },
    } = state;

    return {
        email,
        referrer,
        referrerAffiliate,
        heroTitle,
        horizontalPromos,
        verticalPromos,
    };
};

export default connect(mapStateToProps)(Home);
